function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys, key, i;
    if (typeof Reflect !== "undefined" && Reflect.ownKeys) {
        sourceKeys = Reflect.ownKeys(Object(source));
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
        return target;
    }
    target = _object_without_properties_loose(source, excluded);
    if (Object.getOwnPropertySymbols) {
        sourceKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys = Object.getOwnPropertyNames(source), key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as SelectPrimitive from '@radix-ui/react-select';
import { CheckIcon, ChevronDownIcon, ChevronUpIcon } from 'lucide-react';
import * as React from 'react';
import { cn } from '../../lib/utils';
function Select(_0) {
    let {} = _0, props = _extends({}, _0);
    return /*#__PURE__*/ _jsx(SelectPrimitive.Root, _object_spread({
        "data-slot": "select"
    }, props));
}
function SelectGroup(_0) {
    let {} = _0, props = _extends({}, _0);
    return /*#__PURE__*/ _jsx(SelectPrimitive.Group, _object_spread({
        "data-slot": "select-group"
    }, props));
}
function SelectValue(_0) {
    let {} = _0, props = _extends({}, _0);
    return /*#__PURE__*/ _jsx(SelectPrimitive.Value, _object_spread({
        "data-slot": "select-value"
    }, props));
}
function SelectTrigger(_0) {
    let { className, size = 'default', children } = _0, props = _object_without_properties(_0, [
        "className",
        "size",
        "children"
    ]);
    return /*#__PURE__*/ _jsxs(SelectPrimitive.Trigger, _object_spread_props(_object_spread({
        "data-slot": "select-trigger",
        "data-size": size,
        className: cn("border-input data-placeholder:text-muted-foreground [&_svg:not([class*='text-'])]:text-muted-foreground focus-visible:border-ring focus-visible:ring-ring/50 aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive dark:bg-input/30 dark:hover:bg-input/50 flex w-fit items-center justify-between gap-2 rounded-md border bg-transparent px-3 py-2 text-sm whitespace-nowrap shadow-xs transition-[color,box-shadow] outline-none focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50 data-[size=default]:h-9 data-[size=sm]:h-8 *:data-[slot=select-value]:line-clamp-1 *:data-[slot=select-value]:flex *:data-[slot=select-value]:items-center *:data-[slot=select-value]:gap-2 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4", className)
    }, props), {
        children: [
            children,
            /*#__PURE__*/ _jsx(SelectPrimitive.Icon, {
                asChild: true,
                children: /*#__PURE__*/ _jsx(ChevronDownIcon, {
                    className: "size-4 opacity-50"
                })
            })
        ]
    }));
}
function SelectContent(_0) {
    let { className, children, position = 'popper', align = 'center' } = _0, props = _object_without_properties(_0, [
        "className",
        "children",
        "position",
        "align"
    ]);
    return /*#__PURE__*/ _jsx(SelectPrimitive.Portal, {
        children: /*#__PURE__*/ _jsxs(SelectPrimitive.Content, _object_spread_props(_object_spread({
            "data-slot": "select-content",
            className: cn('bg-popover text-popover-foreground data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 relative z-50 max-h-(--radix-select-content-available-height) min-w-[8rem] origin-(--radix-select-content-transform-origin) overflow-x-hidden overflow-y-auto rounded-md border shadow-md', position === 'popper' && 'data-[side=bottom]:translate-y-1 data-[side=left]:-translate-x-1 data-[side=right]:translate-x-1 data-[side=top]:-translate-y-1', className),
            position: position,
            align: align
        }, props), {
            children: [
                /*#__PURE__*/ _jsx(SelectScrollUpButton, {}),
                /*#__PURE__*/ _jsx(SelectPrimitive.Viewport, {
                    className: cn('p-1', position === 'popper' && 'h-[var(--radix-select-trigger-height)] w-full min-w-[var(--radix-select-trigger-width)] scroll-my-1'),
                    children: children
                }),
                /*#__PURE__*/ _jsx(SelectScrollDownButton, {})
            ]
        }))
    });
}
function SelectLabel(_0) {
    let { className } = _0, props = _object_without_properties(_0, [
        "className"
    ]);
    return /*#__PURE__*/ _jsx(SelectPrimitive.Label, _object_spread({
        "data-slot": "select-label",
        className: cn('text-muted-foreground px-2 py-1.5 text-xs', className)
    }, props));
}
function SelectItem(_0) {
    let { className, children } = _0, props = _object_without_properties(_0, [
        "className",
        "children"
    ]);
    return /*#__PURE__*/ _jsxs(SelectPrimitive.Item, _object_spread_props(_object_spread({
        "data-slot": "select-item",
        className: cn("focus:bg-accent focus:text-accent-foreground text-foreground [&_svg:not([class*='text-'])]:text-muted-foreground relative flex w-full cursor-default items-center gap-2 rounded-sm py-1.5 pr-8 pl-2 text-sm outline-hidden select-none data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4 *:[span]:last:flex *:[span]:last:items-center *:[span]:last:gap-2", className)
    }, props), {
        children: [
            /*#__PURE__*/ _jsx("span", {
                className: "absolute right-2 flex size-3.5 items-center justify-center",
                children: /*#__PURE__*/ _jsx(SelectPrimitive.ItemIndicator, {
                    children: /*#__PURE__*/ _jsx(CheckIcon, {
                        className: "size-4"
                    })
                })
            }),
            /*#__PURE__*/ _jsx(SelectPrimitive.ItemText, {
                children: children
            })
        ]
    }));
}
function SelectSeparator(_0) {
    let { className } = _0, props = _object_without_properties(_0, [
        "className"
    ]);
    return /*#__PURE__*/ _jsx(SelectPrimitive.Separator, _object_spread({
        "data-slot": "select-separator",
        className: cn('bg-border pointer-events-none -mx-1 my-1 h-px', className)
    }, props));
}
function SelectScrollUpButton(_0) {
    let { className } = _0, props = _object_without_properties(_0, [
        "className"
    ]);
    return /*#__PURE__*/ _jsx(SelectPrimitive.ScrollUpButton, _object_spread_props(_object_spread({
        "data-slot": "select-scroll-up-button",
        className: cn('flex cursor-default items-center justify-center py-1', className)
    }, props), {
        children: /*#__PURE__*/ _jsx(ChevronUpIcon, {
            className: "size-4"
        })
    }));
}
function SelectScrollDownButton(_0) {
    let { className } = _0, props = _object_without_properties(_0, [
        "className"
    ]);
    return /*#__PURE__*/ _jsx(SelectPrimitive.ScrollDownButton, _object_spread_props(_object_spread({
        "data-slot": "select-scroll-down-button",
        className: cn('flex cursor-default items-center justify-center py-1', className)
    }, props), {
        children: /*#__PURE__*/ _jsx(ChevronDownIcon, {
            className: "size-4"
        })
    }));
}
export { Select, SelectContent, SelectGroup, SelectItem, SelectLabel, SelectScrollDownButton, SelectScrollUpButton, SelectSeparator, SelectTrigger, SelectValue };
